import {
  ArrowRightOutlined,
  EuroCircleFilled,
  RestOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Modal, Radio, Space, Tooltip } from "antd";
import { Carousel } from "primereact/carousel";
import { Fragment, useEffect, useRef, useState } from "react";
import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaEuroSign,
  FaSync,
} from "react-icons/fa";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiChevronLeft,
  TiChevronRight,
  TiEquals,
  TiTime,
} from "react-icons/ti";
import { NumericFormat } from "react-number-format";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ComposedChart,
  Line,
  Pie,
  PieChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip as Tip,
  XAxis,
  YAxis,
} from "recharts";
import { CustumedMatrix } from "tamtam-components";
import {
  getCollaboratorsSuggestions,
  getFinancialFollowUp,
  getMonthFinancial,
  getPeriodFinancialList,
  resetFollowUp,
  updateClientForfaitReviewStatus,
  updateClientMonthlyBudget,
} from "../../api";
import { getPartners } from "../../api/partners";
import { DELETED_STATUS } from "../../config";
import _ from "../../i18n";
import {
  capitalize,
  formatAmount,
  generateFullName,
  getTimeByDurationFormat,
  getUserNameForAvatar,
  hexToRgb,
  parsePreference,
  renderTeamYears,
  toFixed,
  useOnClickOutside,
  viewDataBy,
} from "../../utils";
import TTPFilterHorizontalBar from "../common/Filter/TTPFilterHorizontalBar";
import {
  ClipBoardIcon,
  FolderIcon,
  IconClose,
  IconThreeDots,
  LoopIcon,
} from "../common/Icons";
import {
  billing_types,
  colors,
  getSearchValueStyle,
  monthNames,
  monthToIndex,
  suspecionTabs,
  tabs_1,
} from "./Constants";
import DraggableDialog from "./Components/DraggableDialog";
import DraggableSettingDialog from "./Components/DraggableSettingsDialog";

export default function DeltaSideBarFrame({
  organization,
  token,
  onClose,
  ...rest
}) {
  const { preferences, user, collaborator, loggedAs, language: lng } = rest;
  const [currentMonth, setCurrentMonth] = useState({
    index: null,
    name: null,
  });
  const [list, setList] = useState([]);
  const [totalData, setTotalData] = useState([]);
  const [totals, setTotals] = useState({
    budgetHr: 0,
    prestaTS: 0,
    economic: 0,
    turnover: 0,
    expectedTurnover: 0,
    gapHr: 0,
    gapEconomic: 0,
    minimumBilling: 0,
    adjustedEco: 0,
    adjustedHr: 0,
    upToPrevMonthBudget: {
      budgetHr: 0,
      economic: 0,
    },
    diff: {
      prestaTS: 0,
      economic: 0,
      gap: 0,
    },
  });
  const [nbResults, setNbResults] = useState(0);
  const [clients, setClients] = useState([]);
  const [pieChartData, setPieChartData] = useState([]);
  const [periodData, setPeriodData] = useState([]);
  const [followUpData, setFollowUpData] = useState(null);
  const [periodChartData, setPeriodChartData] = useState({
    task: [],
    ca: [],
    minBillingTotal: 0,
    economicBudgetToal: 0,
  });
  const [partnerOptions, setPartnerOptions] = useState([]);
  const [collaboratorOptions, setCollaboratorOptions] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [filter, setFilter] = useState({
    year: new Date().getFullYear(),
    partner:
      parsePreference(preferences).financialState.allowViewDataBy === 11
        ? user?.id
        : null,
    collaborators:
      [10, 110].includes(
        parsePreference(preferences).financialState.allowViewDataBy
      ) && collaborator
        ? [collaborator.id]
        : [],
    deletedStatus: "NOT_DELETED",
    partnerZone: 1,
    page: 1,
    pageSize: 100,
    keyWord: "",
    billingType: null,
    suspect: false,
  });
  const [yearDivIsVisible, setYearDivIsVisible] = useState(false);
  const [activeView, setActiveView] = useState("TAB");
  const [updatedBudget, setUpdatedBudget] = useState({
    budgetHr: null,
    economicBudget: null,
  });
  const [isUpdating, setIsUpdating] = useState(false);
  const [isMultiSelection, setIsMultiSelection] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const ref = useRef();
  useOnClickOutside(ref, () => setYearDivIsVisible(false));

  useEffect(() => {
    const today = new Date();
    const currentMonthIndex = today.getMonth();
    const currentDay = today.getDate();

    const effectiveIndex =
      currentDay <= 15 ? currentMonthIndex - 1 : currentMonthIndex;

    const adjustedIndex = effectiveIndex < 0 ? 1 : effectiveIndex;
    const adjustedName = monthNames[adjustedIndex];

    setCurrentMonth({
      index: adjustedIndex,
      name: adjustedName,
    });
  }, []);

  useEffect(() => {
    if (filter.partner) {
      const options = collaborators.filter((c) => c.partner == filter.partner);
      setCollaboratorOptions(options);
    } else {
      setCollaboratorOptions(collaborators);
    }
  }, [filter.partner, collaborators]);

  useEffect(() => {
    const selected =
      list && list.filter((client) => clients.includes(client.clientId));

    const newTotals =
      selected && selected.length > 0
        ? selected.reduce(
            (acc, client) => {
              acc.budgetHr += parseFloat(client.budgetHr.total) || 0;
              acc.prestaTS += parseFloat(client.prestaTS.total) || 0;
              acc.economic += parseFloat(client.economic.total) || 0;
              acc.turnover += parseFloat(client.turnover.total) || 0;
              return acc;
            },
            { budgetHr: 0, prestaTS: 0, economic: 0, turnover: 0 }
          )
        : { ...totalData };

    const diffHr =
      newTotals.budgetHr > 0
        ? (newTotals.prestaTS * 100) / newTotals.budgetHr
        : 0;
    const diffEconomic =
      newTotals.economic > 0
        ? (newTotals.turnover * 100) / newTotals.economic
        : 0;

    setTotals((prevTotals) => ({
      ...prevTotals,
      ...newTotals,
      diff: {
        prestaTS: diffHr,
        economic: diffEconomic,
        gap: diffEconomic - diffHr,
      },
    }));
  }, [list, clients, totalData]);

  useEffect(() => {
    if (!list) return;
    const selected =
      clients &&
      clients.length > 0 &&
      list.filter((client) => clients.includes(client.clientId));

    let chartData;
    let minBillingTotal = 0;
    if (selected.length > 0) {
      const taskByCategory = {};
      selected.forEach((client) => {
        const tasks = client.task?.sub || {};

        for (const key in tasks) {
          const task = tasks[key];
          if (!taskByCategory[key]) {
            taskByCategory[key] = {
              label: task.label,
              duration: 0,
              valuation: 0,
            };
          }

          minBillingTotal += parseFloat(task.valuation) || 0;
          taskByCategory[key].duration += task.duration || 0;
          taskByCategory[key].valuation += parseFloat(task.valuation) || 0;
        }
      });

      chartData = Object.values(taskByCategory).map((task, index) => ({
        name: task.label,
        value: task.valuation,
        fill: colors[index % colors.length],
      }));
    } else {
      chartData =
        totalData &&
        totalData.task &&
        Object.values(totalData.task.sub).map((task, index) => ({
          name: task.label,
          value: task.valuation,
          fill: colors[index % colors.length],
        }));
    }

    setPeriodChartData({
      ...periodChartData,
      minBillingTotal,
    });
    setTotals((prevTotals) => ({
      ...prevTotals,
      minimumBilling: minBillingTotal,
    }));
    setPieChartData(chartData);
  }, [list, clients, totalData]);

  useEffect(() => {
    let updatedBudgetHr = {};
    let updatedBudgetEco = {};

    if (followUpData && followUpData.length) {
      followUpData
        .filter((elem) => elem.month !== "")
        .forEach((elem) => {
          updatedBudgetHr[elem.month] = elem.followUp.budgetHr.toFixed(2);
          updatedBudgetEco[elem.month] = elem.followUp.economicBudget;
        });
    }

    setUpdatedBudget({
      budgetHr: updatedBudgetHr,
      economicBudget: updatedBudgetEco,
    });
  }, [clients, followUpData]);

  let financialSheetListQuery = useQuery(
    ["financialSheetList", token, organization.id, filter, searchKeyWord],
    async () => {
      if (token && organization) {
        try {
          const response = await getPeriodFinancialList(
            token,
            organization.id,
            { ...filter, keyWord: searchKeyWord }
          );
          return response.data.data;
        } catch (error) {
          console.error("Financial List >> Err: ", error);
          return [];
        }
      }
    },
    {
      enabled: !!token && !!organization && !!filter,
      onSuccess: (data) => {
        setNbResults(data.list.totalCount);
        setTotalData(data.total);
        setList(data.list.pagination);
        setClients((prevClients) => prevClients || []);
      },
    }
  );

  let financialPeriodDataQuery = useQuery(
    ["financialPriodData", token, organization.id, clients, filter],
    async () => {
      if (token && organization) {
        try {
          const response = await getMonthFinancial(token, organization.id, {
            ...filter,
            clients,
          });
          return response.data.data;
        } catch (error) {
          console.error("Financial List >> Err: ", error);
          return [];
        }
      }
    },
    {
      enabled: !!token && !!organization && !!clients && !!filter,
      onSuccess: (data) => {
        setPeriodData(data);
      },
    }
  );

  const handleSave = (updatedBudget) => {
    const hourBudget = periodData
      .filter((elem) => elem.month !== "")
      .reduce((acc, elem) => {
        acc[elem.month] = parseFloat(elem.budget.budgetHr).toFixed(2);
        return acc;
      }, {});

    const economicBudget = periodData
      .filter((elem) => elem.month !== "")
      .reduce((acc, elem) => {
        acc[elem.month] = parseFloat(elem.budget.economicBudget).toFixed(2);
        return acc;
      }, {});
    const payload = {
      clientId: clients[0],
      year: filter.year,
      hourBudget: updatedBudget?.budgetHr
        ? updatedBudget?.budgetHr
        : hourBudget,
      economicBudget: updatedBudget?.economicBudget
        ? updatedBudget?.economicBudget
        : economicBudget,
    };

    updateClientMonthlyBudget(token, organization.id, payload)
      .then((resp) => {
        if (resp.data.result === "OK") {
          toast.success(_("successfully_added"));
          followUpPeriodDataQuery.refetch();
        }
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.data &&
          e.response.data.errors &&
          e.response.data.errors.length > 0
        )
          toast.error(_(e.response.data.errors[0].message));
        else toast.error(_("error"));
      })
      .finally(() => setIsUpdating(false));
  };

  let followUpPeriodDataQuery = useQuery(
    ["followPriodData", token, organization.id, clients, filter],
    async () => {
      if (financialSheetListQuery.isFetched && token && organization) {
        try {
          const response = await getFinancialFollowUp(token, organization.id, {
            ...filter,
            clients,
          });
          return response.data.data;
        } catch (error) {
          console.error("Financial List >> Err: ", error);
          return [];
        }
      }
    },
    {
      enabled: !!token && !!organization && !!clients && !!filter,
      onSuccess: (data) => {
        setFollowUpData(data);

        const taskData = [];
        const caData = [];

        if (data) {
          const filteredData = data.filter((item) => item.month !== "");
          let accumulatedTurnover = 0;
          let accumulateBudget = 0;
          let accumulateMinBilling = 0;
          let expectedTurnover = 0;
          let adjustedHr = 0;
          let adjustedEco = 0;
          let gapHr = 0;
          let gapEconomic = 0;
          let upToPrevMonthHr = 0;
          let upToPrevMonthEconomic = 0;

          // const currentMonthIndex = new Date().getMonth();
          // const currentMonthKey = monthNames[currentMonthIndex];
          // const hasCurrentMonthData = data.some(
          //   (m) =>
          //     m.month.toLowerCase() === currentMonthKey &&
          //     m.followUp &&
          //     typeof m.followUp.turnover === "number" &&
          //     m.followUp.turnover > 0
          // );
          // const effectiveMonthIndex = hasCurrentMonthData
          //   ? currentMonthIndex
          //   : currentMonthIndex - 1;

          filteredData.forEach((item) => {
            const month = item.month;
            const budget = item.followUp;

            if (budget) {
              taskData.push({
                month,
                budgetHr: budget.budgetHr / 60,
                prestaTs: budget.prestaTs / 60,
              });

              accumulatedTurnover +=
                monthToIndex[month] > currentMonth.index
                  ? budget.economicBudget
                  : budget.turnover;
              expectedTurnover +=
                monthToIndex[month] > currentMonth.index
                  ? budget.economicBudget
                  : 0;
              accumulateBudget += budget.economicBudget;
              accumulateMinBilling +=
                monthToIndex[month] > currentMonth.index
                  ? ((budget.budgetHr / 60) * totals.minimumBilling) /
                    totals.budgetHr
                  : budget.minimumBilling;
              adjustedEco += budget.adjustedEco ?? 0;
              adjustedHr += (budget.adjustedHr ?? 0) / 60;

              gapHr +=
                monthToIndex[month] < currentMonth.index
                  ? (budget.gapHr ?? 0) / 60
                  : 0;
              gapEconomic +=
                monthToIndex[month] < currentMonth.index
                  ? budget.extra ?? 0
                  : 0;

              upToPrevMonthHr +=
                monthToIndex[month] <= currentMonth.index
                  ? (budget.budgetHr ?? 0) / 60
                  : 0;

              upToPrevMonthEconomic +=
                monthToIndex[month] <= currentMonth.index
                  ? budget.economicBudget ?? 0
                  : 0;

              caData.push({
                month,
                turnover: budget.turnover,
                economicBudget: budget.economicBudget,
                minimumBilling: budget.minimumBilling,
                accumulateBudget: accumulateBudget,
                accumulateMinBilling: accumulateMinBilling,
                accumulateTurnover: accumulatedTurnover,
              });
            }
          });

          setTotals((prev) => ({
            ...prev,
            gapHr,
            gapEconomic,
            expectedTurnover,
            adjustedEco,
            adjustedHr,
            upToPrevMonthBudget: {
              budgetHr: upToPrevMonthHr,
              economic: upToPrevMonthEconomic,
            },
          }));
        }

        setPeriodChartData({
          ...periodChartData,
          task: taskData,
          ca: caData,
        });
      },
    }
  );

  const handleResetFollowUp = () => {
    resetFollowUp(token, organization.id, {
      ...filter,
      clients,
    })
      .then((resp) => {
        if (resp.data.result === "OK") {
          followUpPeriodDataQuery.refetch();
          toast.success(_("followUpResetSuccessfully"));
        }
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.data &&
          e.response.data.errors &&
          e.response.data.errors.length > 0
        )
          toast.error(_(e.response.data.errors[0].message));
        else toast.error(_("error"));
      })
      .finally(() => setOpenConfirmModal(false));
  };

  let partnersQuery = useQuery(
    ["partnersQuery", token, organization.id],
    async () => {
      if (token && organization) {
        const response = await getPartners({
          token,
          organizationId: organization?.id,
        });
        const data = response.data.data.map((partner) => ({
          value: partner.id,
          label: partner.name,
          zone: partner.zone,
        }));
        setPartnerOptions(data);
        if (parsePreference(preferences.clients).allowViewDataBy === 11) {
          const zone = data.find((p) => p.value === Number(user?.id)).zone;
          setFilter({ ...filter, partnerZone: zone });
        }
        return data;
      }
    },
    {
      enabled: !!token && !!organization,
    }
  );

  let collaboratorsdQuery = useQuery(
    ["getCollaborators", token, organization.id],
    async () => {
      if (token && organization) {
        try {
          const response = await getCollaboratorsSuggestions(
            token,
            organization.id
          );
          let data = response.data.data;
          let list = viewDataBy(
            preferences,
            data,
            collaborator,
            "dynamicTable"
          );
          data = list
            .filter((item) => item !== null)
            .map((t) => {
              return {
                value: t.id,
                label: t.name,
                partner: t?.partner?.value,
                isActif: t.isActif,
              };
            });
          setCollaborators(
            list.map((c) => ({
              value: c.id,
              label: c.name,
              partner: c?.partner?.value,
              isActif: c.isActif,
            }))
          );
          setCollaboratorOptions(data);
        } catch (e) {
          return null;
        }
      }
    }
  );

  const updateReviewStatus = async (status) => {
    try {
      await updateClientForfaitReviewStatus({
        uid: user.uid,
        token,
        organization: organization.id,
        client: clients[0],
        status,
      })
        .then((res) => {
          if (res.data.result === "OK") {
            // setReviewStatus(status);
            toast.success(_("successfully_updated"));
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (error) {
      console.error("Error updating review state:", error);
    }
  };

  const handleInputChange = (column, month, prevValue, value) => {
    setIsUpdating(true);

    const key = column === "prestaTs" ? "budgetHr" : "economic";
    const columnKey = column === "prestaTs" ? "budgetHr" : "economicBudget";
    const newPrevValue = key === "budgetHr" ? prevValue / 60 : prevValue;
    setTotals((prevTotals) => ({
      ...prevTotals,
      [key]: prevTotals[key] - newPrevValue + value,
    }));

    const newFollowUpData = followUpData.map((item) =>
      item.month == month
        ? {
            ...item,
            followUp: {
              ...item.followUp,
              [columnKey]: key === "budgetHr" ? value * 60 : value,
            },
          }
        : { ...item }
    );

    setFollowUpData(newFollowUpData);

    setUpdatedBudget((prev) => ({
      ...prev,
      [columnKey]: {
        ...(prev[columnKey] || {}),
        [month]: key === "budgetHr" ? value * 60 : value,
      },
    }));
  };

  const handleOnCancel = () => {
    followUpPeriodDataQuery.refetch();
    setIsUpdating(false);
  };

  const handleColumns = (column, line) => {
    const currentIndex = new Date().getMonth();
    switch (column.id) {
      case "budget":
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              gap: 10,
              fontSize: 12,
            }}
          >
            {Object.keys(line.budget).map((key, index) => {
              const matchedItem =
                followUpData &&
                followUpData.length &&
                followUpData.find((item) => item.month == line.month);
              const followUpValue =
                matchedItem &&
                matchedItem.followUp &&
                Math.round(matchedItem.followUp[key]);
              const turnover =
                matchedItem &&
                matchedItem.followUp &&
                Math.round(matchedItem.followUp["turnover"]);
              const budgetValue = Math.round(line.budget[key]);
              return (
                <div
                  key={`${key}-${index}`}
                  style={{
                    flex: 1,
                    textAlign: "center",
                    // textDecoration: (() => {
                    //   if (!followUpData) return "none";
                    //   if (!matchedItem || !matchedItem.followUp) return "none";
                    //   return followUpValue > budgetValue ||
                    //     followUpValue < budgetValue
                    //     ? "1px #de4848 line-through"
                    //     : "none";
                    // })(),
                  }}
                >
                  {periodData.indexOf(line) === 0 && <span>{_(key)}</span>}
                  {periodData.indexOf(line) > 0 ? (
                    key == "budgetHr" ? (
                      getTimeByDurationFormat(toFixed(line.budget[key] / 60, 2))
                    ) : (
                      <NumericFormat
                        value={line.budget[key].toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        suffix=" €"
                      />
                    )
                  ) : (
                    <></>
                  )}
                </div>
              );
            })}
          </div>
        );
      case "followUp":
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              gap: 8,
              fontSize: 12,
              textAlign: "center",
            }}
          >
            {Object.keys(line.followUp)
              .filter(
                (key) => !["gapHr", "budgetHr", "economicBudget"].includes(key)
              )
              .map((key, index) => {
                const isFirstLine =
                  followUpData && followUpData.indexOf(line) === 0;
                const isNotFirstLine =
                  followUpData && followUpData.indexOf(line) > 0;
                const isPresta = key === "prestaTs" || key === "adjustedHr";
                const isTurnover = key === "turnover";
                const isBudgetEditable =
                  key === "prestaTs" || key === "turnover";

                const monthIndex = new Date(`${line.month} 1, 2000`).getMonth();
                const isCurrentYear = filter.year === new Date().getFullYear();
                const showValue = isCurrentYear
                  ? monthIndex <= currentIndex
                  : true;
                const isEditable = isCurrentYear && monthIndex > currentIndex;

                const renderValue = () => {
                  if (isBudgetEditable && isEditable) {
                    const defaultValue = isTurnover
                      ? updatedBudget.economicBudget
                      : updatedBudget.budgetHr;

                    return (
                      <div
                        key={`${key}-${index}`}
                        className="input-field"
                        style={{
                          opacity:
                            clients.length > 1 || clients.length == 0 ? 0.7 : 1,
                        }}
                      >
                        <input
                          type="number"
                          disabled={disabled}
                          value={
                            (key === "prestaTs"
                              ? (defaultValue[line.month] / 60).toFixed(2)
                              : defaultValue[line.month]) || 0
                          }
                          onChange={(e) =>
                            handleInputChange(
                              key,
                              line.month,
                              Number(defaultValue[line.month]),
                              Number(e.target.value)
                            )
                          }
                          style={{
                            cursor:
                              clients.length > 1 ||
                              (clients.length == 0 && "not-allowed"),
                          }}
                        />
                        {isTurnover ? <span>€</span> : <span>h</span>}
                      </div>
                    );
                  }

                  if (isPresta) {
                    return (
                      <span
                        style={{
                          textDecoration:
                            key === "budgetHr" &&
                            line.followUp["budgetHr"] !==
                              line.followUp["adjustedHr"]
                              ? "1px line-through solid #de4848"
                              : "",
                        }}
                      >
                        {getTimeByDurationFormat(
                          toFixed(line.followUp[key] / 60, 2)
                        )}
                      </span>
                    );
                  }

                  const formattedValue = (
                    <div
                      style={{ position: "relative" }}
                      key={`${key}-${index}`}
                    >
                      <NumericFormat
                        value={Math.abs(line.followUp[key]).toFixed(2)}
                        displayType="text"
                        thousandSeparator="."
                        decimalSeparator=","
                        suffix=" €"
                        style={{
                          textDecoration:
                            key === "economicBudget" &&
                            line.followUp["economicBudget"] !==
                              line.followUp["adjustedEco"]
                              ? "1px line-through solid #de4848"
                              : "",
                        }}
                      />
                      {isTurnover ? (
                        <div
                          key={`${key}-${index}`}
                          style={{
                            position: "absolute",
                            right: 10,
                            top: "calc(50% - 5px)",
                            transform:
                              line.followUp["turnover"] -
                                line.followUp["economicBudget"] >
                              0
                                ? "rotate(0)"
                                : "rotate(180deg)",
                            backgroundColor:
                              line.followUp["turnover"] -
                                line.followUp["economicBudget"] >
                              0
                                ? "#02af8e"
                                : line.followUp["turnover"] -
                                    line.followUp["economicBudget"] <
                                  0
                                ? "#de4848"
                                : "#ea8124",
                            borderRadius: 100,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 10,
                            height: 10,
                          }}
                        >
                          {line.followUp["turnover"] -
                            line.followUp["economicBudget"] ==
                          0 ? (
                            <TiEquals size={8} color="#fafbfb" />
                          ) : (
                            <TiArrowSortedUp size={12} color="#fafbfb" />
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  );

                  if (
                    (isTurnover ||
                      key === "minimumBilling" ||
                      key === "extra") &&
                    !showValue
                  )
                    return <div key={`${key}-${index}`} />;
                  return formattedValue;
                };

                return (
                  <div
                    key={index}
                    style={{
                      flex: 1,
                      color:
                        key === "extra" && line.followUp[key] > 0
                          ? "#02af8e"
                          : key === "extra" && line.followUp[key] < 0
                          ? "#de4848"
                          : "#64748B",
                    }}
                  >
                    {isFirstLine && (
                      <span style={{ color: "#6d7f92" }}>{_(key)}</span>
                    )}
                    {isNotFirstLine ? renderValue() : null}
                  </div>
                );
              })}
          </div>
        );
    }
  };

  const handleTitle = (title) => (
    <Fragment>
      {periodData.indexOf(title) > 0 && (
        <div
          style={{ border: 0, display: "flex", justifyContent: "flex-start" }}
        >
          <div>{_(title.month)}</div>
        </div>
      )}
    </Fragment>
  );

  const renderActiveViewContent = () => {
    switch (activeView) {
      case "TAB":
        return (
          <Fragment>
            {clients.length && totals ? (
              <div className="totals-container">
                <div className="totals">
                  <div>
                    {/* <SettingsIcon size={14} /> */}
                    <span style={{ fontWeight: 600 }}>
                      {_("annualObjectif")}
                    </span>
                  </div>
                  <div className="float-rate-badge">
                    <NumericFormat
                      value={
                        (totals?.economic / totals?.budgetHr)?.toFixed(0) || 0
                      }
                      displayType={"text"}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      suffix={totals.adjustedHr ? "" : " €/h"}
                    />
                    {followUpData && followUpData.length ? (
                      <>
                        <ArrowRightOutlined style={{ fontSize: 14 }} />
                        <NumericFormat
                          value={
                            (totals?.adjustedEco / totals?.adjustedHr)?.toFixed(
                              0
                            ) || 0
                          }
                          displayType={"text"}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          suffix=" €/h"
                        />
                      </>
                    ) : null}
                  </div>
                  <div>
                    <div>
                      <p>{_("schedule")}</p>
                      <span className={totals.adjustedHr ? "line-through" : ""}>
                        {getTimeByDurationFormat(totals?.budgetHr || 0)}
                      </span>
                      {followUpData && followUpData.length ? (
                        <div className="adjusted-value">
                          {getTimeByDurationFormat(totals?.adjustedHr || 0)}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      <p>{_("economic")}</p>
                      <NumericFormat
                        value={totals?.economic?.toFixed(2) || 0}
                        displayType={"text"}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        suffix=" €"
                        className={totals.adjustedHr ? "line-through" : ""}
                      />
                      {followUpData && followUpData.length ? (
                        <div>
                          <NumericFormat
                            value={totals.adjustedEco?.toFixed(2) || 0}
                            displayType={"text"}
                            thousandSeparator={"."}
                            decimalSeparator={","}
                            suffix=" €"
                            className="adjusted-value"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {/* {clients.length ? (
                        <div
                          style={{
                            flexDirection: "column",
                            alignItems: "flex-start",
                            width: "100%",
                          }}
                        >
                          <div>
                            {`Budget de Janvier → ${
                              new Date(filter.year, new Date().getMonth() - 1)
                                .toLocaleString("fr-FR", { month: "long" })
                                .charAt(0)
                                .toUpperCase() +
                              new Date(filter.year, new Date().getMonth() - 1)
                                .toLocaleString("fr-FR", { month: "long" })
                                .slice(1)
                            }:`}
                          </div>
                          <div className="sub-totals">
                            <div>
                              <p>{_("schedule")}</p>
                              <span>
                                {getTimeByDurationFormat(
                                  totals?.upToPrevMonthBudget?.budgetHr || 0
                                )}
                              </span>
                            </div>
                            <div>
                              <p>{_("economic")}</p>
                              <NumericFormat
                                value={
                                  totals?.upToPrevMonthBudget?.economic?.toFixed(
                                    2
                                  ) || 0
                                }
                                displayType={"text"}
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                suffix=" €"
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )} */}
                </div>

                <div className="sub-container">
                  <div className="circular-chart">
                    <div className="card-header">
                      {/* <SettingsIcon size={14} /> */}
                      <span>
                        {`${_("real")} de Janvier → ${_(
                          capitalize(currentMonth.name)
                        )}`}
                      </span>
                    </div>
                    <LinearProgressBar
                      id="budgetHr"
                      label={_("prestaTs")}
                      total={totals?.budgetHr || 0}
                      value={totals?.prestaTS || 0}
                      budget={totals?.upToPrevMonthBudget.budgetHr || 0}
                      color="#02af8e"
                    />
                    <LinearProgressBar
                      id="economic"
                      label={_("turnover")}
                      type="*"
                      total={totals?.economic || 0}
                      value={totals?.turnover || 0}
                      budget={totals?.upToPrevMonthBudget.economic || 0}
                      color="#d87318"
                      gap={totals?.diff.gap || 0}
                      min={totals?.minimumBilling || 0}
                    />
                  </div>
                </div>

                <div className="sub-container">
                  <div className="circular-chart">
                    <div className="card-header">
                      {/* <SettingsIcon size={14} /> */}
                      <span>Fact. Min vs CA</span>
                    </div>
                    <div className="legend">
                      <div className="legend-text">
                        <p>{_("minimumBilling")}</p>
                        <div>
                          <NumericFormat
                            value={totals?.minimumBilling?.toFixed(2) || 0}
                            displayType={"text"}
                            thousandSeparator={"."}
                            decimalSeparator={","}
                            suffix=" €"
                          />
                          {totals.diff.gap > 0 ? (
                            <>
                              <div className="arrow-right">
                                <span>{`+${Math.round(
                                  totals.diff.gap
                                )}%`}</span>
                                <ArrowRightOutlined style={{ fontSize: 14 }} />
                              </div>
                              <NumericFormat
                                value={
                                  (
                                    totals?.minimumBilling +
                                    (totals?.minimumBilling *
                                      totals?.diff.gap) /
                                      100
                                  ).toFixed(2) || 0
                                }
                                displayType={"text"}
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                suffix=" €"
                              />
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    {totals?.diff.gap < 0 ? (
                      <div className="legend">
                        <div className="legend-text">
                          <p>{_("turnover")}</p>
                          <div>
                            <NumericFormat
                              value={totals?.turnover?.toFixed(2) || 0}
                              displayType={"text"}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              suffix=" €"
                            />
                            <div className="arrow-right">
                              <span>{`+${Math.abs(totals.diff.gap).toFixed(
                                1
                              )}%`}</span>
                              <ArrowRightOutlined style={{ fontSize: 14 }} />
                            </div>
                            <NumericFormat
                              value={
                                (
                                  totals?.turnover +
                                  (totals?.turnover *
                                    Math.abs(totals?.diff.gap)) /
                                    100
                                ).toFixed(2) || 0
                              }
                              displayType={"text"}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              suffix=" €"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="sub-container">
                  <div className="circular-chart">
                    <div
                      className="gap-badge"
                      style={{
                        color:
                          totals.diff.gap < 5 &&
                          totals.diff.gap > -5 &&
                          "#18a0fb",
                        backgroundColor:
                          totals.diff.gap < 5 &&
                          totals.diff.gap > -5 &&
                          "#18a0fb25",
                        borderColor:
                          totals.diff.gap < 5 &&
                          totals.diff.gap > -5 &&
                          "#18a0fb75",
                      }}
                    >
                      {totals.diff.gap > 5
                        ? "à crédit"
                        : totals.diff.gap < -5
                        ? "à découvert"
                        : "à l'équilibre"}
                    </div>
                    <div className="card-header">
                      {/* <SettingsIcon size={14} /> */}
                      <span>Equilibre de Fact.</span>
                    </div>
                    <div>{`${_("schedule")} (H)`}</div>
                    <div
                      className="balance-container"
                      style={{
                        "--after-left": `${
                          totals?.diff.economic >= 100
                            ? 100
                            : totals?.diff.economic
                        }%`,
                        "--before-left": `${
                          totals?.diff.prestaTS >= 100
                            ? 100
                            : totals?.diff.prestaTS
                        }%`,
                      }}
                    >
                      <div
                        className="balance-gap"
                        style={{
                          "--gap-width": `${Math.abs(
                            Math.min(totals?.diff.economic, 100) -
                              Math.min(totals?.diff.prestaTS, 100)
                          )}%`,
                          "--gap-left": `${Math.min(
                            Math.min(totals?.diff.economic, 100),
                            Math.min(totals?.diff.prestaTS, 100)
                          )}%`,
                          "--gap-right": `${Math.max(
                            Math.min(totals?.diff.economic, 100),
                            Math.min(totals?.diff.prestaTS, 100)
                          )}%`,
                        }}
                      />
                    </div>
                    <div>{`${_("ca")} (€)`}</div>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="follow-up-container">
              <div>
                {periodData && (
                  <CustumedMatrix
                    columns={[
                      {
                        id: "budget",
                        label: `${_("budgetObjectif")} ${filter.year}`,
                        isEditable: true,
                        widthPercentage: 75,
                      },
                    ]}
                    items={periodData}
                    handleCellule={handleColumns}
                    handleTitle={handleTitle}
                    headerTagBG={"#FFFFFF"}
                    headerTagColor
                  />
                )}
              </div>
              <div className="follow-up-matrix">
                {followUpData && followUpData.length > 0 ? (
                  <>
                    <CustumedMatrix
                      columns={[
                        {
                          id: "followUp",
                          label: _("Follow-Up"),
                          isEditable: true,
                          widthPercentage: 100,
                        },
                      ]}
                      items={followUpData}
                      handleCellule={handleColumns}
                      handleTitle={(title) => <Fragment></Fragment>}
                      headerTagBG={"#FFFFFF"}
                      headerTagColor
                    />
                  </>
                ) : (
                  <div className="follow-up-generate-btn">
                    <div>
                      <img
                        src="https://stats.tamtam.pro/img/icons/manage-BM/follow-up.svg"
                        alt="follow-up-img"
                      />
                    </div>
                    <h4>Aucun Follow-up n'a été généré</h4>
                    <p>
                      {` Prenez le temps de configurer soigneusement votre budget
                    objectif ${filter.year} avant de générer tout follow-up.`}
                    </p>
                    <button
                      disabled={clients.length > 1 || clients.length == 0}
                      style={{
                        cursor:
                          clients.length > 1 || clients.length == 0
                            ? "not-allowed"
                            : "pointer",
                        opacity:
                          clients.length > 1 || clients.length == 0 ? 0.7 : 1,
                      }}
                      onClick={handleSave}
                    >
                      Générer Follow-Up
                    </button>
                  </div>
                )}
              </div>
            </div>
          </Fragment>
        );
      case "CHART":
        return followUpData?.length ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 10,
              marginTop: 20,
            }}
          >
            <div className="chart">
              <h3>Réalisé Horaire par Mois</h3>
              <ResponsiveContainer height={300} width="100%">
                <AreaChart
                  width={300}
                  height={300}
                  data={periodChartData.task}
                  margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                  }}
                >
                  <defs>
                    <linearGradient id="colorTask" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#01ae8e" stopOpacity={1} />
                      <stop offset="95%" stopColor="#01ae8e" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <defs>
                    <linearGradient id="colorHr" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#18a0fb" stopOpacity={1} />
                      <stop offset="95%" stopColor="#18a0fb" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid
                    strokeDasharray="3 0"
                    vertical={false}
                    stroke="#64748B10"
                  />
                  <XAxis
                    dataKey="month"
                    tickFormatter={(month) => {
                      return _(month).substring(0, 3);
                    }}
                  />
                  <YAxis
                    axisLine={false}
                    type="number"
                    tickLine={false}
                    tickSize={10}
                    unit="h"
                    tickMargin={20}
                    fill="#64748B"
                  />
                  <Tip
                    content={<CustomTooltip />}
                    cursor={{ fill: "rgba(225, 228, 232, 0.50)" }}
                  />
                  <Area
                    type="monotone"
                    dataKey="budgetHr"
                    stroke="#18a0fb"
                    fill="url(#colorHr)"
                  />
                  <Area
                    type="monotone"
                    dataKey="prestaTs"
                    stroke="#01ae8e"
                    fill="url(#colorTask)"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
            <div className="pie-chart-container">
              <div className="pie-chart">
                {pieChartData && pieChartData.length > 0 ? (
                  <Fragment>
                    <div>
                      <p>{_("minimumBilling")}</p>
                      <NumericFormat
                        value={pieChartData
                          .reduce((sum, entry) => sum + entry.value, 0)
                          .toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        suffix=" €"
                      />
                    </div>
                    <Tooltip
                      placement="leftBottom"
                      className="legend-tooltip"
                      overlayInnerStyle={{
                        color: "#29394d",
                        width: 400,
                        position: "absolute",
                        right: 0,
                        bottom: 0,
                        fontSize: 12,
                        fontWeight: 500,
                      }}
                      color="#f0f0f0"
                      title={<CustomLegend />}
                    >
                      <div className="euro-sign">
                        <EuroCircleFilled />
                      </div>
                    </Tooltip>
                    <div className="chart-container">
                      <div className="chart-area">
                        <ResponsiveContainer>
                          <PieChart>
                            <Pie
                              data={pieChartData}
                              cx="50%"
                              cy="50%"
                              labelLine={false}
                              outerRadius={90}
                              fill="#8884d8"
                              dataKey="value"
                            >
                              {pieChartData.map((entry, index) => (
                                <Cell
                                  key={`cell-${index}`}
                                  fill={colors[index % colors.length]}
                                />
                              ))}
                            </Pie>
                            <Tooltip
                              formatter={(value) => `$${value.toFixed(2)}`}
                            />
                          </PieChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </Fragment>
                ) : (
                  <div className="empty-state">
                    <p>No task data available</p>
                  </div>
                )}
              </div>

              <div className="chart">
                <h3>{_("annualEstimate")}</h3>
                <ResponsiveContainer width="100%" height={200}>
                  <BarChart
                    height={200}
                    data={[
                      {
                        name: "CA",
                        turnover: totals?.turnover || 0,
                        expectedTurnover: totals?.expectedTurnover || 0,
                      },
                    ]}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid
                      strokeDasharray="3 0"
                      vertical={false}
                      stroke="#64748B10"
                    />
                    <XAxis dataKey="name" />
                    <YAxis
                      axisLine={false}
                      type="number"
                      tickLine={false}
                      tickSize={10}
                      unit="€"
                      tickMargin={20}
                      fill="#64748B"
                      domain={[
                        0,
                        (dataMax) =>
                          Math.max(
                            dataMax,
                            Math.max(
                              Math.round(
                                (
                                  totals.minimumBilling +
                                  (totals.minimumBilling *
                                    (100 - totals.diff.prestaTS)) /
                                    100
                                ).toFixed(2)
                              ),
                              Math.round(totals?.economic)
                            ) + 500
                          ),
                      ]}
                    />

                    <Tip
                      content={<CustomTooltip />}
                      cursor={{ fill: "rgba(225, 228, 232, 0.50)" }}
                    />
                    <Bar
                      dataKey="turnover"
                      stackId="a"
                      barSize={20}
                      fill="#ea8025"
                    />
                    <Bar
                      dataKey="expectedTurnover"
                      stackId="a"
                      barSize={20}
                      fill="#28394c"
                      radius={[1, 1, 0, 0]}
                    />
                    <ReferenceLine
                      y={(
                        totals.minimumBilling +
                        (totals.minimumBilling * (100 - totals.diff.prestaTS)) /
                          100
                      ).toFixed(2)}
                      stroke="#de4848"
                      strokeDasharray="0"
                      label={{
                        value: `${_("minimumBilling")} ${(
                          totals.minimumBilling +
                          (totals.minimumBilling *
                            (100 - totals.diff.prestaTS)) /
                            100
                        ).toFixed(2)}€`,
                        position: "insideBottomLeft",
                        fill: "#de4848",
                        fontSize: 12,
                      }}
                    />
                    <ReferenceLine
                      y={totals?.economic}
                      stroke="#18a0fb"
                      strokeDasharray="0"
                      label={{
                        value: `${_("economicBudget")} ${totals?.economic}€`,
                        position: "insideBottomRight",
                        fill: "#18a0fb",
                        fontSize: 12,
                      }}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className="chart">
              <h3>C.A. par Mois</h3>
              <ResponsiveContainer width="100%" height={300}>
                <ComposedChart
                  width={500}
                  height={300}
                  data={periodChartData.ca}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  barGap={2}
                >
                  <defs>
                    <linearGradient
                      id="colorEconomic"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="0" stopColor="#18a0fb" stopOpacity={1} />
                      <stop offset="100%" stopColor="#18a0fb" stopOpacity={0} />
                    </linearGradient>
                  </defs>

                  <defs>
                    <linearGradient id="colorCA" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0" stopColor="#d87317" stopOpacity={1} />
                      <stop offset="100%" stopColor="#d87317" stopOpacity={0} />
                    </linearGradient>
                  </defs>

                  <CartesianGrid
                    strokeDasharray="3 0"
                    vertical={false}
                    stroke="#64748B10"
                  />
                  <XAxis
                    dataKey="month"
                    tickFormatter={(month) => _(month).substring(0, 3)}
                  />
                  <YAxis
                    axisLine={false}
                    type="number"
                    tickLine={false}
                    tickSize={10}
                    unit="€"
                    tickMargin={20}
                    fill="#64748B"
                  />
                  <Tip
                    content={<CustomTooltip />}
                    cursor={{ fill: "rgba(225, 228, 232, 0.50)" }}
                  />

                  <Bar
                    dataKey="economicBudget"
                    fill="#18a0fb"
                    barSize={10}
                    radius={[1, 1, 0, 0]}
                  />

                  <Bar
                    dataKey="minimumBilling"
                    fill="#28394c"
                    barSize={10}
                    radius={[1, 1, 0, 0]}
                  />

                  <Bar
                    dataKey="turnover"
                    fill="#ea8025"
                    barSize={10}
                    radius={[1, 1, 0, 0]}
                  />

                  {/* Accumulate data over past months */}
                  <Line
                    type="monotone"
                    dataKey="accumulateBudget"
                    stroke="#18a0fb75"
                    strokeWidth={2}
                    dot={{ r: 3 }}
                    activeDot={{ r: 5 }}
                  />
                  <Line
                    type="monotone"
                    dataKey="accumulateMinBilling"
                    stroke="#28394c75"
                    strokeWidth={2}
                    dot={{ r: 3 }}
                    activeDot={{ r: 5 }}
                  />
                  <Line
                    type="monotone"
                    dataKey="accumulateTurnover"
                    stroke="#ea802575"
                    strokeWidth={2}
                    dot={{ r: 3 }}
                    activeDot={{ r: 5 }}
                  />
                </ComposedChart>
              </ResponsiveContainer>
            </div>
          </div>
        ) : (
          <div
            className="follow-up-container"
            style={{ width: "100%", display: "flex" }}
          >
            <div className="follow-up-matrix" style={{ margin: "auto" }}>
              <div className="follow-up-generate-btn">
                <div>
                  <img
                    src="https://stats.tamtam.pro/img/icons/manage-BM/follow-up.svg"
                    alt="follow-up-img"
                  />
                </div>
                <h4>Aucun Follow-up n'a été généré</h4>
                <p>
                  {` Prenez le temps de configurer soigneusement votre budget
                    objectif ${filter.year} avant de générer tout follow-up.`}
                </p>
                <button
                  disabled={clients.length > 1 || clients.length == 0}
                  style={{
                    cursor:
                      clients.length > 1 || clients.length == 0
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      clients.length > 1 || clients.length == 0 ? 0.7 : 1,
                  }}
                  onClick={handleSave}
                >
                  Générer Follow-Up
                </button>
              </div>
            </div>
          </div>
        );
      default:
        return <div />;
    }
  };

  const renderYearSelect = () => {
    return (
      <div
        ref={ref}
        className={
          "customed_select" +
          " " +
          (yearDivIsVisible ? "customed_select_opened" : "")
        }
        style={{
          background: "#6d7f92",
          color: "#ffffff",
          zIndex: 9999,
        }}
      >
        <div
          className={"customed_select_header"}
          onClick={() => setYearDivIsVisible(!yearDivIsVisible)}
        >
          <span>{filter.year}</span>
          <div className={"actions"}>
            <div>
              <span className={"action"}>
                <TiArrowSortedDown />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={"customed_select_body"}>
            <div className={"customed_select_body_options"}>
              {renderTeamYears().map((item, index) => (
                <div
                  key={index}
                  className={"customed_select_body_option"}
                  onClick={() => setFilter({ ...filter, year: item })}
                  style={{ zIndex: 4 }}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleSelectClients = (item) => {
    if (isMultiSelection) {
      setClients((prev) => {
        const isSelected = prev.includes(item.clientId);

        if (isSelected) {
          return prev.filter((id) => id !== item.clientId);
        } else {
          return [...prev, item.clientId];
        }
      });
    } else {
      setClients([item.clientId]);
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchKeyWord(value);
  };

  const clearAll = () => {
    setSearchKeyWord("");
  };

  const handlePartnerChange = (partner) => {
    const selected = partnerOptions.find((p) => p.value === Number(partner));
    setSelectedPartner(selected);
    setFilter({
      ...filter,
      partner: Number(partner),
      partnerZone: selected?.zone,
    });
  };

  const handleSetDeletedStatus = (status) => {
    setFilter({ ...filter, deletedStatus: status });
  };

  const handleCollaboratorsChange = (items) => {
    const actifs = collaborators
      .filter((item) => item.isActif)
      .map((item) => item.value);

    const updatedSelection = ["SUPERADMIN", "ADMIN"].includes(loggedAs)
      ? [...items]
      : [...actifs, ...items];

    setFilter({ ...filter, collaborators: [...new Set(updatedSelection)] });
  };

  const filters = [
    {
      type: "SELECT",
      options: {
        isSimple: false,
        isMulti: true,
        isClearable: false,
        isSearch: true,
        placeholder: _("collaborator"),
        options: collaboratorOptions,
        values: filter.collaborators,
        action: handleCollaboratorsChange,
      },
    },
    {
      type: "SELECT",
      options: {
        isSimple: true,
        isClearable: false,
        placeholder: _("clientState"),
        options: DELETED_STATUS,
        values: filter.deletedStatus,
        action: handleSetDeletedStatus,
      },
    },
  ];

  if (
    [1, 11].includes(
      parsePreference(preferences).financialState.allowViewDataBy
    )
  ) {
    filters.unshift({
      type: "SELECT",
      options: {
        isSimple: true,
        isClearable: true,
        isSearch: true,
        isDisabled:
          parsePreference(preferences).financialState.allowViewDataBy === 11,
        placeholder: _("partner"),
        options: partnerOptions,
        values:
          loggedAs === "COLLABORATOR" &&
          parsePreference(preferences).financialState.allowViewDataBy === 11
            ? collaborator?.partner?.value
            : filter.partner,
        action: handlePartnerChange,
      },
    });
  }

  const renderFilterFrame = () => {
    const label = selectedPartner?.label || "";
    const [firstName, lastName] = label.split(" ");

    const selectedCollaborators = collaboratorOptions.filter((co) =>
      filter.collaborators.includes(co.value)
    );

    return (
      <div>
        <div
          className="principal-line"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="billing_types_wrapper">
            {selectedPartner && (
              <Fragment>
                <Tooltip placement="top" title={selectedPartner?.label}>
                  {renderAvatar("", firstName, lastName)}
                </Tooltip>
                <div className="divider" />
              </Fragment>
            )}
            {selectedCollaborators.length ? (
              <Fragment>
                <div className="avatars_stuck">
                  {selectedCollaborators.map((co) => {
                    const [fname, lname] = co.label.split(" ");
                    return (
                      <Tooltip key={co.value} placement="top" title={co?.label}>
                        {renderAvatar("", fname, lname)}
                      </Tooltip>
                    );
                  })}
                </div>
                <div className="divider" />
              </Fragment>
            ) : (
              ""
            )}
            <div className="billing_types">
              {billing_types.map((t, index) => (
                <div
                  key={index}
                  style={{ "--border-color": t.color }}
                  className={`${
                    filter.billingType == t.value ? "active_billing_type" : ""
                  }`}
                  onClick={() => {
                    setClients([]);
                    setFilter({ ...filter, billingType: t.value });
                  }}
                >
                  {t.label}
                </div>
              ))}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {renderYearSelect()}
            <TTPFilterHorizontalBar
              button
              bg="#FFF"
              subBG="F8F9FA"
              filter={filter}
              filters={filters}
              nbResult={nbResults}
              pageSize={pageSize}
              updateFilterContent={setFilter}
              cssClass="filter-horizontal-button-delta"
            />
          </div>
        </div>
      </div>
    );
  };

  const { pageSize, page } = filter;

  const CustomLegend = () => (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 7,
      }}
    >
      {pieChartData
        .filter((entry) => entry.value > 0)
        .map((entry, index) => (
          <div
            key={`legend-${index}`}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 7,
              width: "100%",
            }}
          >
            <div
              style={{
                backgroundColor: colors[index % colors.length],
                width: 10,
                height: 10,
                borderRadius: "100%",
              }}
            />
            <div
              className="legend-content"
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 10,
                width: "100%",
              }}
            >
              {entry.name && entry.name.length > 40 ? (
                <Tooltip placement="top" title={entry.name} mouseLeaveDelay={0}>
                  <span className="legend-name">{`${entry.name.substring(
                    0,
                    40
                  )}...`}</span>
                </Tooltip>
              ) : (
                <span className="legend-name">{entry.name}</span>
              )}
              <NumericFormat
                value={entry.value.toFixed(1)}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                suffix=" €"
              />
            </div>
          </div>
        ))}
    </div>
  );

  const clientNames = list
    .filter((item) => clients.includes(item.clientId))
    .map((item) => item.clientName)
    .join(", ");

  const disabled =
    clients.length > 1 ||
    clients.length == 0 ||
    list.find((c) => c.clientId == clients[0])?.inReview;

  return (
    <Fragment>
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <div className="sidebar_header">
          <div className="sidebar_header_infos">
            <h3>{_("turnoverManagement")}</h3>
          </div>
          <div className="sidebar_header_right">
            {isUpdating && (
              <div>
                <button
                  onClick={handleOnCancel}
                  style={{
                    "--bg-color": "transparent",
                    "--color": "#29394d",
                    textDecoration: "underline",
                  }}
                >
                  {_("cancel")}
                </button>
                <button
                  className="save-btn"
                  onClick={() => handleSave(updatedBudget)}
                >
                  {_("save")}
                </button>
              </div>
            )}

            <div className="sidebar_header_action">
              <DraggableDialog />
            </div>
            {loggedAs === "SUPERADMIN" || loggedAs === "ADMIN" ? (
              <div className="sidebar_header_action">
                <DraggableSettingDialog />
              </div>
            ) : null}
            <Tooltip placement="bottom" title={_("close")}>
              <div className="sidebar_header_action" onClick={onClose}>
                <IconClose size={12} fill="#29394d" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="sidebar_body vertical_content">
          {renderFilterFrame()}
          <div className="sidebar_body_actions">
            <Radio.Group
              value={isMultiSelection}
              options={[
                { value: false, label: _("selectOneClient") },
                { value: true, label: _("selectMultiClients") },
              ]}
              onChange={(e) => setIsMultiSelection(e.target.value)}
            />
            {/* <div className="separator" />
            <Radio.Group
              value={filter.suspect}
              options={[
                { value: false, label: _("all") },
                { value: true, label: _("suspect") },
              ]}
              onChange={(e) =>
                setFilter({ ...filter, suspect: e.target.value })
              }
            /> */}
            <div className="separator" />
            <div>
              <button
                className="danger"
                onClick={() => setOpenConfirmModal(true)}
              >
                {_("resetFollowUp")}
              </button>
            </div>
            <Modal
              open={openConfirmModal}
              title={<h4 style={{ color: "#29394d" }}>{_("resetFollowUp")}</h4>}
              onCancel={() => setOpenConfirmModal(false)}
              footer={null}
              style={{ color: "#29394d" }}
            >
              <div style={{ padding: 24, color: "#29394d", fontWeight: 400 }}>
                <h3 style={{ fontWeight: 500, color: "#29394d" }}>
                  Êtes-vous sûr de vouloir réinitialiser le Follow-Up&nbsp;?
                </h3>
                <p>
                  Cette action est irréversible et supprimera le Follow-Up
                  généré pour{" "}
                  {clients.length ? (
                    <>
                      le(s) client(s) : <strong>{clientNames}</strong>
                    </>
                  ) : (
                    <strong>tous les clients</strong>
                  )}
                  .
                </p>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 24,
                  }}
                >
                  <Button
                    onClick={() => setOpenConfirmModal(false)}
                    style={{ marginRight: 8 }}
                  >
                    Annuler
                  </Button>
                  <Button type="primary" danger onClick={handleResetFollowUp}>
                    Confirmer
                  </Button>
                </div>
              </div>
            </Modal>
          </div>
          <div className="content">
            <div className="financial_delta_list">
              <div className="search-box">
                <span className="search-box__icon">
                  <LoopIcon />
                </span>
                <input
                  value={searchKeyWord}
                  placeholder="Search..."
                  onChange={handleSearchChange}
                />
                {nbResults ? (
                  <div style={getSearchValueStyle()}>{nbResults}</div>
                ) : null}
                {searchKeyWord && (
                  <div onClick={clearAll} style={{ cursor: "pointer" }}>
                    <IconClose size={9} />
                  </div>
                )}
              </div>
              <Carousel
                style={{
                  width: "100%",
                  padding: 0,
                  marginBottom: 10,
                  height: "auto",
                }}
                value={suspecionTabs}
                numVisible={2}
                numScroll={0}
                showNavigators={false}
                itemTemplate={(category, i) => {
                  return (
                    <div
                      key={i}
                      className={`tab_badge ${
                        filter.suspect === category.value
                          ? "tab_badge_active"
                          : ""
                      }`}
                      style={{
                        minWidth: "50%",
                        width: "auto",
                        padding: "5px 0",
                      }}
                      onClick={() =>
                        setFilter({ ...filter, suspect: category.value })
                      }
                    >
                      <div style={{ textTransform: "capitalize" }}>
                        {_(category.label)}
                      </div>
                    </div>
                  );
                }}
              />
              <div className="list_wrapper">
                {financialSheetListQuery.isFetching ? (
                  <div
                    style={{
                      height: "100vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Loading...
                  </div>
                ) : list ? (
                  list.map((item, index) => {
                    return (
                      <div
                        key={`${index}-${item.clientId}`}
                        className={`list_item ${
                          clients.includes(item.clientId) ? "selected" : ""
                        }`}
                        onClick={() => handleSelectClients(item)}
                      >
                        <div className="client-name-wrapper">
                          {item.clientName && item.clientName.length > 13 ? (
                            <Tooltip
                              placement="top"
                              title={item.clientName}
                              mouseLeaveDelay={0}
                            >
                              <span>{`${item.clientName.substring(
                                0,
                                13
                              )}...`}</span>
                            </Tooltip>
                          ) : (
                            <span>{item.clientName}</span>
                          )}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            gap: 10,
                            alignItems: "center",
                            paddingRight: 10,
                          }}
                        >
                          {item.inReview ? (
                            <Tooltip
                              placement="top"
                              title={_("inForfaitReview")}
                            >
                              <FaSync size={12} fill="#FFAC3A" />
                            </Tooltip>
                          ) : item.suspectType === "ALL" ? (
                            <>
                              <div className="suspect-badge">
                                <FaEuroSign color="#de4848" />
                              </div>
                              <div className="suspect-badge">
                                <TiTime color="#de4848" />
                              </div>
                            </>
                          ) : item.suspectType === "HOUR" ? (
                            <div className="suspect-badge">
                              <TiTime color="#de4848" />
                            </div>
                          ) : item.suspectType === "ECONOMIC" ? (
                            <div className="suspect-badge">
                              <FaEuroSign color="#de4848" />
                            </div>
                          ) : (
                            ""
                          )}

                          <div className="underlay">
                            <Dropdown
                              menu={{
                                items: [
                                  {
                                    label: (
                                      <Link
                                        to={`/${lng}/forfait/${item.clientId}`}
                                      >
                                        <FolderIcon fill="#18A0FB" />
                                        {_("forfait")}
                                      </Link>
                                    ),
                                    key: "0",
                                  },
                                  {
                                    label: (
                                      <Link
                                        to={`/${lng}/fiche-client/${item.clientId}`}
                                      >
                                        <ClipBoardIcon size={12} />
                                        {_("ficheClient")}
                                      </Link>
                                    ),
                                    key: "1",
                                  },
                                  item.portal && {
                                    label: (
                                      <Link
                                        to={item.portal}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          src="https://static.intercomassets.com/avatars/6472131/square_128/Group_39910-1744282782.png"
                                          alt="recovr_logo"
                                          width={12}
                                        />
                                        {_("Portail client")}
                                      </Link>
                                    ),
                                    key: "2",
                                  },
                                  { type: "divider" },
                                  {
                                    label: (
                                      <div
                                        onClick={() =>
                                          updateReviewStatus("IN_REVIEW")
                                        }
                                        disabled={disabled}
                                        className="primary"
                                        style={{
                                          cursor: disabled
                                            ? "not-allowed"
                                            : "pointer",
                                          opacity: disabled ? 0.5 : 1,
                                          textTransform: "capitalize",
                                          pointerEvents: disabled
                                            ? "none"
                                            : "all",
                                        }}
                                      >
                                        <FaSync size={12} />
                                        {_("review")}
                                      </div>
                                    ),
                                    key: "3",
                                  },
                                  {
                                    label: (
                                      <div
                                        className="danger"
                                        onClick={() =>
                                          setOpenConfirmModal(true)
                                        }
                                      >
                                        <RestOutlined size={12} />
                                        {_("resetFollowUp")}
                                      </div>
                                    ),
                                    key: "4",
                                  },
                                ],
                              }}
                              // trigger={["click"]}
                            >
                              <a onClick={(e) => e.preventDefault()}>
                                <Space>
                                  <IconThreeDots size={14} />
                                </Space>
                              </a>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div style={{ padding: "100px 0" }}>{_("noData")}</div>
                )}
              </div>
              <div
                className="paginator"
                style={{ display: "flex", gap: "8px", marginTop: "10px" }}
              >
                <button
                  disabled={page <= 1}
                  onClick={() =>
                    setFilter((prev) => ({
                      ...prev,
                      page: prev.page - 1,
                    }))
                  }
                >
                  <TiChevronLeft />
                </button>
                <p>{`Page ${page}/${Math.ceil(nbResults / pageSize)}`}</p>
                <button
                  disabled={list && list.length < pageSize}
                  onClick={() =>
                    setFilter((prev) => ({
                      ...prev,
                      page: prev.page + 1,
                    }))
                  }
                >
                  <TiChevronRight />
                </button>
              </div>
            </div>
            <div className="graph-container">
              <div className="tabs">
                {tabs_1.map((tab) => (
                  <div
                    key={tab.id}
                    className={`tab ${
                      activeView == tab.id ? "active-tab" : ""
                    }`}
                    style={{
                      display:
                        followUpData?.length === 0 &&
                        tab.id === "CHART" &&
                        "none",
                    }}
                    onClick={() => setActiveView(tab.id)}
                  >
                    {tab.icon}
                    {tab.label}
                  </div>
                ))}
              </div>
              {financialSheetListQuery.isFetching ||
              financialPeriodDataQuery.isFetching ? (
                <div className="ripple_loading">
                  <img src={"/img/Ripple-1s-150px.svg"} alt="ripple" />
                </div>
              ) : financialSheetListQuery.isFetched &&
                financialPeriodDataQuery.isFetched ? (
                <div className="view-content">{renderActiveViewContent()}</div>
              ) : (
                <div>{_("noData")}</div>
              )}
            </div>
            <div className="circular-chart-container">
              {/* {followUpData && followUpData.length ? (
                <div>
                  <div style={{ fontWeight: 600, marginBottom: 5 }}>
                    Résultat d'ajustement annuel:
                    <br />
                    du {`01/01/${filter.year}`} au {`31/12/${filter.year}`}
                  </div>
                  {/* <span>Comparaison du réalisé avec le budget objectif</span> 
                  <div className="totals">
                    <div>
                      <AdjustIcon size={18} fill="#18a0fb" />
                      <span>{_("totalAdjustment")}</span>
                    </div>
                    <div className="float-rate-badge">
                      <NumericFormat
                        value={
                          (totals?.adjustedEco / totals?.adjustedHr)?.toFixed(
                            1
                          ) || 0
                        }
                        displayType={"text"}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        suffix=" €/h"
                      />
                    </div>
                    <div>
                      <div>
                        <p>{_("schedule")}</p>
                        <span>
                          {getTimeByDurationFormat(totals?.adjustedHr || 0)}
                        </span>
                      </div>
                      <div>
                        <p>{_("economic")}</p>
                        <NumericFormat
                          value={totals?.adjustedEco?.toFixed(2) || 0}
                          displayType={"text"}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          suffix=" €"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )} */}
              {/* {totals ? (
                <div>
                  <div style={{ marginBottom: 10 }}>
                    <div style={{ fontWeight: 600 }}>
                      Résultat du budget courant:
                      <br />
                      du {`01/01/${filter.year}`} au{" "}
                      {new Date().toLocaleDateString("fr-FR")}
                    </div>
                    <span>Comparaison du réalisé avec le budget objectif</span>
                  </div>
                  <div className="sub-container">
                    <div id="budgetHr" className="circular-chart">
                      <LinearProgressBar
                        id="budgetHr"
                        label={_("prestaTs")}
                        total={totals?.budgetHr || 0}
                        value={totals?.prestaTS || 0}
                        color="#02af8e"
                      />
                    </div>
                    <div id="economic" className="circular-chart">
                      <LinearProgressBar
                        id="economic"
                        label={_("turnover")}
                        type="*"
                        total={totals?.economic || 0}
                        value={totals?.turnover || 0}
                        color="#d87318"
                        gap={totals?.diff.gap || 0}
                        min={totals?.minimumBilling || 0}
                      />
                    </div>
                    <div>
                      <div style={{ fontWeight: 600 }}>
                        Analyse du budget courant:
                      </div>
                      <div>
                        <span>
                          Equilibre entre la facturation et la prestation
                        </span>
                      </div>
                      <div className="circular-chart" style={{ marginTop: 5 }}>
                        <div
                          className="gap-badge"
                          style={{
                            color:
                              totals.diff.gap < 5 &&
                              totals.diff.gap > -5 &&
                              "#18a0fb",
                            backgroundColor:
                              totals.diff.gap < 5 &&
                              totals.diff.gap > -5 &&
                              "#18a0fb25",
                            borderColor:
                              totals.diff.gap < 5 &&
                              totals.diff.gap > -5 &&
                              "#18a0fb75",
                          }}
                        >
                          {totals.diff.gap > 5
                            ? "à crédit"
                            : totals.diff.gap < -5
                            ? "à découvert"
                            : "à l'équilibre"}
                        </div>
                        <div>{`${_("schedule")} (H)`}</div>
                        <div
                          className="balance-container"
                          style={{
                            "--after-left": `${
                              totals?.diff.economic >= 100
                                ? 100
                                : totals?.diff.economic
                            }%`,
                            "--before-left": `${
                              totals?.diff.prestaTS >= 100
                                ? 100
                                : totals?.diff.prestaTS
                            }%`,
                          }}
                        >
                          <div
                            className="balance-gap"
                            style={{
                              "--gap-width": `${Math.abs(
                                totals?.diff.economic - totals?.diff.prestaTS
                              )}%`,
                              "--gap-left": `${Math.min(
                                totals?.diff.economic,
                                totals?.diff.prestaTS
                              )}%`,
                              "--gap-right": `${Math.max(
                                totals?.diff.economic,
                                totals?.diff.prestaTS
                              )}%`,
                            }}
                          />
                        </div>
                        <div>{`${_("ca")} (€)`}</div>
                      </div>
                    </div>
                    <div>
                      <span>Ajustement du facturation minimum</span>
                      <div className="circular-chart" style={{ marginTop: 5 }}>
                        <div className="legend">
                          <div className="legend-text">
                            <p>{_("minimumBilling")}</p>
                            <div>
                              <NumericFormat
                                value={totals?.minimumBilling?.toFixed(2) || 0}
                                displayType={"text"}
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                suffix=" €"
                              />
                              {totals.diff.gap > 0 ? (
                                <>
                                  <div className="arrow-right">
                                    <span>{`+${totals.diff.gap.toFixed(
                                      1
                                    )}%`}</span>
                                    <ArrowRightOutlined
                                      style={{ fontSize: 14 }}
                                    />
                                  </div>
                                  <NumericFormat
                                    value={
                                      (
                                        totals?.minimumBilling +
                                        (totals?.minimumBilling *
                                          totals?.diff.gap) /
                                          100
                                      ).toFixed(2) || 0
                                    }
                                    displayType={"text"}
                                    thousandSeparator={"."}
                                    decimalSeparator={","}
                                    suffix=" €"
                                  />
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {totals?.diff.gap < 0 ? (
                      <div>
                        <span>{`Ajustement du C.A. pour ${totals.diff.prestaTS.toFixed(
                          1
                        )}% de prestation`}</span>
                        <div
                          className="circular-chart"
                          style={{ marginTop: 5 }}
                        >
                          <div className="legend">
                            <div className="legend-text">
                              <p>{_("turnover")}</p>
                              <div>
                                <NumericFormat
                                  value={totals?.turnover?.toFixed(2) || 0}
                                  displayType={"text"}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  suffix=" €"
                                />
                                <div className="arrow-right">
                                  <span>{`+${Math.abs(totals.diff.gap).toFixed(
                                    1
                                  )}%`}</span>
                                  <ArrowRightOutlined
                                    style={{ fontSize: 14 }}
                                  />
                                </div>
                                <NumericFormat
                                  value={
                                    (
                                      totals?.turnover +
                                      (totals?.turnover *
                                        Math.abs(totals?.diff.gap)) /
                                        100
                                    ).toFixed(2) || 0
                                  }
                                  displayType={"text"}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  suffix=" €"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {followUpData && followUpData.length > 0 && totals ? (
                <div className="totals">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      <DiffOutlined style={{ color: "#18a0fb" }} size={30} />
                      <span>{_("cumulativeGap")}</span>
                    </div>
                    <p style={{ marginTop: -5 }}>
                      {`Diff. réalisé - Budget de Janvier → ${
                        new Date(filter.year, new Date().getMonth() - 1)
                          .toLocaleString("fr-FR", { month: "long" })
                          .charAt(0)
                          .toUpperCase() +
                        new Date(filter.year, new Date().getMonth() - 1)
                          .toLocaleString("fr-FR", { month: "long" })
                          .slice(1)
                      }`}
                    </p>
                  </div>
                  <div>
                    <div>
                      <p>{_("schedule")}</p>
                      <span
                        style={{
                          color: totals?.gapHr < 0 ? "#de4848" : "#02af8e",
                        }}
                      >
                        {getTimeByDurationFormat(Math.abs(totals?.gapHr) || 0)}
                      </span>
                    </div>
                    <div>
                      <p>{_("economic")}</p>
                      <NumericFormat
                        value={Math.abs(totals?.gapEconomic).toFixed(1) || 0}
                        displayType={"text"}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        suffix=" €"
                        style={{
                          color:
                            totals?.gapEconomic < 0 ? "#de4848" : "#02af8e",
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )} */}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const CircularChart = ({
  label,
  total,
  value,
  color,
  id = "progress",
  type = "time",
}) => {
  const progress = total > 0 ? (value / total) * 100 : 0;
  const gradientId = `textGradient-${id}`;

  return (
    <Fragment>
      <div className="legend">
        {/* <div className="legend-color" style={{ backgroundColor: color }} /> */}
        <div className="legend-text">
          <p>{label}</p>
          <strong>
            {type == "time" ? (
              getTimeByDurationFormat(value)
            ) : (
              <NumericFormat
                value={value ? value.toFixed(2) : 0}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                suffix=" €"
              />
            )}
          </strong>
        </div>
      </div>
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        className="circular-progress"
        style={{
          "--progress": progress,
        }}
      >
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop
              offset="0%"
              style={{ stopColor: "#29394d", stopOpacity: 1 }}
            />
            <stop offset="100%" style={{ stopColor: color, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
        <circle className="bg"></circle>
        <circle className="fg" style={{ "--fill": color }}></circle>
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dy="0.3em"
          className="progress-text"
          fill={`url(#${gradientId})`}
        >
          {`${Math.round(progress)}%`}
        </text>
      </svg>
    </Fragment>
  );
};

const LinearProgressBar = ({
  label,
  total,
  value,
  budget,
  color,
  id = "progress",
  type = "time",
  gap = 0,
  min = 0,
}) => {
  const progress = total > 0 ? (value / total) * 100 : 0;
  const adjustedMin = gap > 0 ? min + (min * gap) / 100 : min;
  const positionLeft = total > 0 ? (adjustedMin / total) * 100 : 0;
  const diff = value - budget;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems:
          type != "time" && progress >= 100 ? "flex-start" : "flex-end",
        marginBottom: type == "time" ? 0 : 20,
      }}
    >
      <div className="bar-legend">
        <strong style={{ fontSize: 14, color: "#29394d" }}>
          {type === "time" ? (
            <div style={{ display: "flex", gap: 7 }}>
              <span>{getTimeByDurationFormat(value)}</span>

              <div
                className="diff-amount"
                style={{
                  "--diff-amount-color":
                    diff <= 0 ? hexToRgb("#02af8e") : hexToRgb("#de4848"),
                }}
              >
                {diff > 0 ? (
                  <FaAngleDoubleUp color="#de4848" size={12} />
                ) : (
                  <FaAngleDoubleDown color="#02af8e" size={12} />
                )}
                <span
                  style={{
                    "--diff-amount-color": diff <= 0 ? "#02af8e" : "#de4848",
                  }}
                >
                  {getTimeByDurationFormat(Math.abs(diff))}
                </span>
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", gap: 7 }}>
              <NumericFormat
                value={value ? value.toFixed(2) : 0}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                suffix=" €"
              />

              <div
                className="diff-amount"
                style={{
                  "--diff-amount-color":
                    diff > 0 ? hexToRgb("#02af8e") : hexToRgb("#de4848"),
                }}
              >
                {diff > 0 ? (
                  <FaAngleDoubleUp color="#02af8e" size={12} />
                ) : (
                  <FaAngleDoubleDown color="#de4848" size={12} />
                )}
                <NumericFormat
                  value={Math.abs(diff)?.toFixed(0)}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  suffix=" €"
                  style={{
                    "--diff-amount-color": diff > 0 ? "#02af8e" : "#de4848",
                  }}
                />
              </div>
            </div>
          )}
        </strong>
        <div
          className="progress-text"
          style={{
            "--bar-text-color":
              progress <= 100 ? hexToRgb(color) : hexToRgb("#de4848"),
          }}
        >{`${Math.round(progress)}%`}</div>
      </div>
      <div className="linear-progress-container">
        {positionLeft > 0 ? (
          <div
            className="cursor"
            style={{
              "--cursor-position-left": `${
                positionLeft >= 100 ? 100 : positionLeft
              }%`,
            }}
            data-min={formatAmount(adjustedMin)}
          />
        ) : null}
        <div
          className="linear-progress-bar"
          style={{
            width: `${progress}%`,
            borderRadius: progress >= 100 ? "5px" : "5px 0 0 5px",
            "--bar-bg-color":
              progress <= 100 ? hexToRgb(color) : hexToRgb("#de4848"),
          }}
        />
      </div>
    </div>
  );
};

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload || payload.length === 0) return null;

  const { month } = payload[0].payload;

  return (
    <div className="custom_tooltip">
      <div className="custom_tooltip_child">{_(month)}</div>
      {payload.map((item, index) => (
        <div key={`${index}-${item.month}`} className="custom_tooltip_child">
          <div>
            <div
              className={`${
                [
                  "budgetHr",
                  "prestaTs",
                  "turnover",
                  "economicBudget",
                  "minimumBilling",
                  "expectedTurnover",
                ].includes(item.name)
                  ? "square"
                  : "line"
              }`}
              style={{ backgroundColor: item.color }}
            />
            <span>{_(item.name)}</span>
          </div>
          <div>
            {item.name == "prestaTs" || item.name == "budgetHr" ? (
              getTimeByDurationFormat(item.value)
            ) : (
              <NumericFormat
                value={item.value.toFixed(2)}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                suffix=" €"
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

const renderAvatar = (avatarUrl, firstName, lastName) => {
  if (!avatarUrl && !firstName && !lastName) {
    return (
      <div className="avatar_not_exist" style={{ cursor: "pointer" }}>
        <p style={{ margin: "auto" }}>-</p>
      </div>
    );
  }
  let avatarDiv;
  if (!avatarUrl) {
    avatarDiv = (
      <div className="avatar_not_exist" style={{ cursor: "pointer" }}>
        <span>{getUserNameForAvatar(firstName, lastName)}</span>
      </div>
    );
  } else {
    avatarDiv = (
      <div className="avatar_exist" style={{ cursor: "pointer" }}>
        <img src={avatarUrl} alt={generateFullName(firstName, lastName)} />
      </div>
    );
  }

  return avatarDiv;
};
